<template>
  <v-data-table
    :headers="headers"
    :items="activeItems"
    class="elevation-1"
    :loading="isLoading"
    :items-per-page="-1"
    sort-by="stockItem.receivingDate"
    :sort-desc="true"
    hide-default-footer
    dense
    no-data-text="No active stock items found"
  >
    <template v-slot:item.sizeRange="{ item }">
      <span v-if="item.stockItem">
        {{ item.stockItem.sizeMin }} - {{ item.stockItem.sizeMax }}
      </span>
    </template>
    <template v-slot:item.updatedBy="{ item }">
      <span v-if="item.updatedBy">{{ item.updatedBy }}</span>
      <span v-else>{{ item.createdBy }}</span>
    </template>
    <template v-slot:item.stockItem.receivedMass="{ item }">
      <span v-if="item.stockItem">
        {{ item.stockItem.receivedMass.toFixed(2) }}
      </span>
    </template>
    <template v-slot:item.stockItem.deliveryNote.receivingDate="{ item }">
      <span v-if="item.stockItem">
        {{ formatDateTime(item.stockItem.deliveryNote.receivingDate) }}
      </span>
    </template>
    <template v-slot:item.updated="{ item }">
      <span v-if="item.updated">{{ formatDateTime(item.updated) }}</span>
      <span v-else>{{ formatDateTime(item.created) }}</span>
    </template>
    <template v-slot:item.actions="{ item, index }">
      <v-btn
        v-if="item.stockItem && item.type === 'Receiving of Cultivated Abolone'"
        small
        :data-cy="`ListActiveProcessCheckSheets-receiving-${index}`"
        color="success"
        :to="{
          name: 'processing-EditReceivingOfCultivatedAbolone',
          query: {
            stockItemId: item.stockItem.id,
            id: item.id
          }
        }">
        Continue
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPencil, mdiDelete } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListStockItemCheckSheets',
  module: 'ProcessCheckSheet',
  mixins: [loading],
  data() {
    return {
      mdiPencil, mdiDelete,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('receivingOfCultivatedAbolones', ['receivingOfCultivatedAbolones']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: 'Receiving Date',
          value: 'stockItem.deliveryNote.receivingDate',
        },
        {
          text: 'Type',
          value: 'type',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Size',
          value: 'sizeRange',
        },
        {
          text: 'Total Received Mass',
          value: 'stockItem.totalReceivedMass',
        },
        {
          text: 'Last Updated by',
          value: 'updatedBy',
        },
        {
          text: 'Last Updated',
          value: 'updated',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
    activeReceivingOfCultivatedAbolones() {
      return this.receivingOfCultivatedAbolones
        .filter((item) => item.status !== 'Completed' && item.stockItem?.stockType !== 'Undefined');
    },
    activeItems() {
      const {
        // eslint-disable-next-line max-len
        activeReceivingOfCultivatedAbolones,
      } = this;
      return [
        ...activeReceivingOfCultivatedAbolones.map((s) => ({ ...s, type: 'Receiving of Cultivated Abolone' })),
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await Promise.all([
      (async () => {
        await this.LOAD_receivingOfCultivatedAbolones();
      })(),
    ]);
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('receivingOfCultivatedAbolones', ['LOAD_receivingOfCultivatedAbolones']),
    /** Delete ProcessCheckSheet from the collection
     */
    async remove(ProcessCheckSheet) {
      this.isLoading = true;
      await this.DELETE_processCheckSheet(ProcessCheckSheet);
      this.isLoading = false;
    },
  },
};
</script>
